import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";
import { resetPayoutDashboardState } from "./payoutAction";
export const FETCH_DATA_PENDING = "FETCH_DATA_PENDING";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";
export const FETCH_DATA_UPDATE = "FETCH_DATA_UPDATE";
export const FETCH_HIERARCHY_DATA = "FETCH_HIERARCHY_DATA";
export const FETCH_TABLE_DATA = "FETCH_TABLE_DATA";
export const RESET_HIERARCHY_DATA = "RESET_HIERARCHY_DATA";
export const FETCH_DATA_ERROR = "FETCH_DATA_ERROR";
export const FETCH_STOCK_TABLE_DATA = "FETCH_STOCK_TABLE_DATA";
export const FETCH_SALES_TABLE_DATA = "FETCH_SALES_TABLE_DATA";
export const SET_HEADER_DATE_FROM = "SET_HEADER_DATE_FROM";
export const SET_HEADER_DATE_TO = "SET_HEADER_DATE_TO";
export const SET_HEADER_UNIT = "SET_HEADER_UNIT";
export const SET_SELECTED_SITE = "SET_SELECTED_SITE";

export const GET_FILTER_DATA = "GET_FILTER_DATA";
export const GET_FILTER_DATA_SUCCESS = "GET_FILTER_DATA_SUCCESS";
export const GET_FILTER_DATA_FAILED = "GET_FILTER_DATA_FAILED";

export const SEGREGATE_DATA_ROLE = "SEGREGATE_DATA_ROLE";

export const GET_ALL_API = "GET_ALL_API";
export const GET_ALL_API_SUCCESS = "GET_ALL_API_SUCCESS";
export const GET_ALL_API_FAILED = "GET_ALL_API_FAILED";

export const GET_DISTRIBUTION_API = "GET_DISTRIBUTION_API";
export const GET_DISTRIBUTION_API_SUCCESS = "GET_DISTRIBUTION_API_SUCCESS";
export const GET_DISTRIBUTION_API_FAILED = "GET_DISTRIBUTION_API_FAILED";

export const GET_SALES_API = "GET_SALES_API";
export const GET_SALES_API_SUCCESS = "GET_SALES_API_SUCCESS";
export const GET_SALES_API_FAILED = "GET_SALES_API_FAILED";

export const GET_SALES_CSV_API = "GET_SALES_CSV_API";
export const GET_SALES_CSV_API_SUCCESS = "GET_SALES_CSV_API_SUCCESS";
export const GET_SALES_CSV_API_FAILED = "GET_SALES_CSV_API_FAILED";

export const GET_RDS_API = "GET_RDS_API";
export const GET_RDS_API_SUCCESS = "GET_RDS_API_SUCCESS";
export const GET_RDS_API_FAILED = "GET_RDS_API_FAILED";

export const GET_STOCK_API = "GET_STOCK_API";
export const GET_STOCK_API_SUCCESS = "GET_STOCK_API_SUCCESS";
export const GET_STOCK_API_FAILED = "GET_STOCK_API_FAILED";

export const GET_STOCK_CSV_API = "GET_STOCK_CSV_API";
export const GET_STOCK_CSV_API_SUCCESS = "GET_STOCK_CSV_API_SUCCESS";
export const GET_STOCK_CSV_API_FAILED = "GET_STOCK_CSV_API_FAILED";

export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_FAILED = "GET_USER_DATA_FAILED";

export const UPDATE_FILTER_VALUE = "UPDATE_FILTER_VALUE";
export const SELECTED_OPTION_DATA = "SELECTED_OPTION_DATA";

export const GET_FILTER_SCHEME_TYPE = "GET_FILTER_SCHEME_TYPE";
export const GET_FILTER_SCHEME_TYPE_SUCCESS = "GET_FILTER_SCHEME_TYPE_SUCCESS";
export const GET_FILTER_SCHEME_TYPE_FAILED = "GET_FILTER_SCHEME_TYPE_FAILED";

export const GET_FILTER_SCHEME_NAME = "GET_FILTER_SCHEME_NAME";
export const GET_FILTER_SCHEME_NAME_SUCCESS = "GET_FILTER_SCHEME_NAME_SUCCESS";
export const GET_FILTER_SCHEME_NAME_FAILED = "GET_FILTER_SCHEME_NAME_FAILED";

export const GET_FETCH_RETAIL_CATEGORY = "GET_FETCH_RETAIL_CATEGORY";
export const GET_FETCH_RETAIL_CATEGORY_FAILED =
  "GET_FETCH_RETAIL_CATEGORY_FAILED";
export const GET_FETCH_RETAIL_CATEGORY_SUCCESS =
  "GET_FETCH_RETAIL_CATEGORY_SUCCESS";

export const GET_DIST_RETAILER_FILTER = "GET_DIST_RETAILER_FILTER";
export const GET_DIST_RETAILER_FILTER_FAILED =
  "GET_DIST_RETAILER_FILTER_FAILED";
export const GET_DIST_RETAILER_FILTER_SUCCESS =
  "GET_DIST_RETAILER_FILTER_SUCCESS";

export const GET_FILTER_JC_AREA = "GET_FILTER_JC_AREA";
export const GET_FILTER_JC_AREA_SUCCESS = "GET_FILTER_JC_AREA_SUCCESS";
export const GET_FILTER_JC_AREA_FAILED = "GET_FILTER_JC_AREA_FAILED";

export const GET_TILES = "GET_TILES";
export const GET_TILES_SUCCESS = "GET_TILES_SUCCESS";
export const GET_TILES_FAILED = "GET_TILES_FAILED";

export const ADD_CATEGORY = "ADD_CATEGORY";
export const GET_TIMESTAMP = "GET_TIMESTAMP";
export const GET_TIMESTAMP_SUCCESS = "GET_TIMESTAMP_SUCCESS";
export const GET_TIMESTAMP_FAILED = "GET_TIMESTAMP_FAILED";

export const SHOW_ALERT_DEVICE = "SHOW_ALERT_DEVICE";
export const HIDE_ALERT_DEVICE = "HIDE_ALERT_DEVICE";

export const SET_RUN = "SET_RUN";
export const UNSET_RUN = "UNSET_RUN";

/** Clears filter UI in homeReducer; keeps header date range + sets needsDashboardHierarchyReseed (mobility reseed). */
export const RESET_FILTERS_TO_DEFAULT = "RESET_FILTERS_TO_DEFAULT";
/** Logout (or explicit session end): restore header from/to + value unit to app defaults. */
export const RESET_HEADER_DATES_TO_CONFIG = "RESET_HEADER_DATES_TO_CONFIG";
/** Clears needsDashboardHierarchyReseed after fetchAPI re-seed runs (or when reseed is not applicable). */
export const CLEAR_DASHBOARD_HIERARCHY_RESEED =
  "CLEAR_DASHBOARD_HIERARCHY_RESEED";

export function resetHeaderDatesToConfig() {
  return { type: RESET_HEADER_DATES_TO_CONFIG };
}

export function setRun() {
  return {
    type: SET_RUN,
  };
}

export function unsetRun() {
  return {
    type: UNSET_RUN,
  };
}

export function fetchShowAlert() {
  return {
    type: SHOW_ALERT_DEVICE,
  };
}

export function hideAlert() {
  return {
    type: HIDE_ALERT_DEVICE,
  };
}

export function triggerFetchTimeStamp(obj, extraData) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}timestamp`,
      dispatch,
      defaultAction: GET_TIMESTAMP,
      successAction: GET_TIMESTAMP_SUCCESS,
      failedAction: GET_TIMESTAMP_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      extraData,
    };
    makeAPICall(params);
  };
}

export function triggerFetchUserConf() {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}`,
      dispatch,
      defaultAction: GET_USER_DATA,
      successAction: GET_USER_DATA_SUCCESS,
      failedAction: GET_USER_DATA_FAILED,
      type: "GET",
      headers: {},
    };
    makeAPICall(params);
  };
}

export function triggerFetchFilterList(obj, callback) {
  return (dispatch) => {
    // Create a new AbortController for this request
    const controller = new AbortController();
    const signal = controller.signal;

    // Store the controller in a variable that can be accessed by other functions
    if (window.currentFilterListController) {
      // Cancel any existing request
      window.currentFilterListController.abort();
    }
    window.currentFilterListController = controller;

    const params = {
      url: `${config.apiBasePath.baseIp}filterList`,
      dispatch,
      defaultAction: GET_FILTER_DATA,
      successAction: GET_FILTER_DATA_SUCCESS,
      failedAction: GET_FILTER_DATA_FAILED,
      type: "POST",
      headers: obj,
      callback,
      signal, // Pass the signal to makeAPICall
    };
    makeAPICall(params);
  };
}

export function triggerFetchRetailerCategory() {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}retailCategory`,
      dispatch,
      defaultAction: GET_FETCH_RETAIL_CATEGORY,
      successAction: GET_FETCH_RETAIL_CATEGORY_SUCCESS,
      failedAction: GET_FETCH_RETAIL_CATEGORY_FAILED,
      type: "POST",
    };
    makeAPICall(params);
  };
}

export function triggerDistRetailerFilter(obj, extraData) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}distRetailerFilter`,
      dispatch,
      defaultAction: GET_DIST_RETAILER_FILTER,
      successAction: GET_DIST_RETAILER_FILTER_SUCCESS,
      failedAction: GET_DIST_RETAILER_FILTER_FAILED,
      callback: obj.callback,
      errCallback: obj.errCallback,
      headers: obj.headers,
      params: obj.params,
      type: "POST",
      extraData,
    };
    makeAPICall(params);
  };
}

export function triggerSchemeType(obj, callback, signal) {
  return (dispatch) => {
    // Create a new AbortController for this request
    const controller = new AbortController();
    const newSignal = controller.signal;

    // Store the controller in a variable that can be accessed by other functions
    if (window.currentSchemeTypeController) {
      // Cancel any existing request
      window.currentSchemeTypeController.abort();
    }
    window.currentSchemeTypeController = controller;

    const params = {
      url: `${config.apiBasePath.baseIp}filterSchemeType`,
      dispatch,
      defaultAction: GET_FILTER_SCHEME_TYPE,
      successAction: GET_FILTER_SCHEME_TYPE_SUCCESS,
      failedAction: GET_FILTER_SCHEME_TYPE_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      callback,
      signal: newSignal, // Use the new signal instead of the passed signal
    };
    makeAPICall(params);
  };
}

export function triggerSchemeName(obj, signal) {
  return (dispatch) => {
    // Create a new AbortController for this request
    const controller = new AbortController();
    const newSignal = controller.signal;

    // Store the controller in a variable that can be accessed by other functions
    if (window.currentSchemeNameController) {
      // Cancel any existing request
      window.currentSchemeNameController.abort();
    }
    window.currentSchemeNameController = controller;

    const params = {
      url: `${config.apiBasePath.baseIp}filterSchemeName`,
      dispatch,
      defaultAction: GET_FILTER_SCHEME_NAME,
      successAction: GET_FILTER_SCHEME_NAME_SUCCESS,
      failedAction: GET_FILTER_SCHEME_NAME_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      signal: newSignal, // Use the new signal instead of the passed signal
    };
    makeAPICall(params);
  };
}

export function triggerJCAreaFilter(obj, extraData, callback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}filterJcArea`,
      dispatch,
      defaultAction: GET_FILTER_JC_AREA,
      successAction: GET_FILTER_JC_AREA_SUCCESS,
      failedAction: GET_FILTER_JC_AREA_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      extraData,
      callback,
    };
    makeAPICall(params);
  };
}

export function triggerFetchAllEndPoints(obj, errCallback) {
  const { callback, ...headers } = obj;
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}hierarchy`, //"http://localhost:5000/hierarchy",
      dispatch,
      headers: headers,
      defaultAction: GET_ALL_API,
      successAction: GET_ALL_API_SUCCESS,
      failedAction: GET_ALL_API_FAILED,
      type: "POST",
      callback: callback,
      errCallback: errCallback,
    };
    makeAPICall(params);
  };
}

export function triggerFetchHierarchyTiles(obj, callback, errCallback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}hierarchy`, //"http://localhost:5000/hierarchy",
      dispatch,
      headers: obj,
      defaultAction: GET_TILES,
      successAction: GET_TILES_SUCCESS,
      failedAction: GET_TILES_FAILED,
      type: "POST",
      callback: callback,
      errCallback: errCallback,
    };
    makeAPICall(params);
  };
}

export function triggerFetchDistributionTable(obj, signal) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}distribution`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_DISTRIBUTION_API,
      successAction: GET_DISTRIBUTION_API_SUCCESS,
      failedAction: GET_DISTRIBUTION_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData,
      signal: signal,
    };
    makeAPICall(params);
  };
}

export function triggerFetchSalesTable(obj, signal) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}sales`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_SALES_API,
      successAction: GET_SALES_API_SUCCESS,
      failedAction: GET_SALES_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData,
      signal: signal,
    };
    setTimeout(function () {
      makeAPICall(params);
    }, 50);
  };
}

export function triggerFetchSalesCsv(obj, callback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}sales-csv`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_SALES_CSV_API,
      successAction: GET_SALES_CSV_API_SUCCESS,
      failedAction: GET_SALES_CSV_API_FAILED,
      type: "POST",
      callback: callback,
      extraData: obj.extraData,
      tab: obj.tab,
    };
    //setTimeout(function () { makeAPICall(params) }, 50);
    makeAPICall(params);
  };
}

export function triggerRDSAPI(obj, callback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}billed`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_RDS_API,
      successAction: GET_RDS_API_SUCCESS,
      failedAction: GET_RDS_API_FAILED,
      type: "POST",
      callback: callback,
      extraData: obj.extraData,
      tab: obj.tab,
    };
    //setTimeout(function () { makeAPICall(params) }, 1500);
    makeAPICall(params);
  };
}

export function triggerStockAPI(obj, signal) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}stock`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_STOCK_API,
      successAction: GET_STOCK_API_SUCCESS,
      failedAction: GET_STOCK_API_FAILED,
      type: "POST",
      callback: obj.callback,
      extraData: obj.extraData,
      signal: signal,
    };
    makeAPICall(params);
    // setTimeout(function () { makeAPICall(params) }, 2000);
  };
}
export function triggerStockCsvAPI(obj, callback) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}stock-inner`,
      dispatch,
      params: obj.params,
      headers: obj.headers,
      defaultAction: GET_STOCK_CSV_API,
      successAction: GET_STOCK_CSV_API_SUCCESS,
      failedAction: GET_STOCK_CSV_API_FAILED,
      type: "POST",
      callback: callback,
      extraData: obj.extraData,
      tab: obj.tab,
    };
    // setTimeout(function () { makeAPICall(params) }, 500);
    makeAPICall(params);
  };
}

// export function triggerSegregateDataForRole(data) {
//   return {
//     type: SEGREGATE_DATA_ROLE,
//     payload: data,
//   };
// }

export function triggerSegregateDataForRole(data, callback) {
  return (dispatch, getState) => {
    dispatch({
      type: SEGREGATE_DATA_ROLE,
      payload: data,
    });

    if (callback && typeof callback === "function") {
      const updatedState = getState();
      callback(updatedState);
    }
  };
}

export function setHeaderDate_From(payload) {
  return {
    type: SET_HEADER_DATE_FROM,
    payload: payload,
  };
}

export function setHeaderDate_To(payload) {
  return {
    type: SET_HEADER_DATE_TO,
    payload: payload,
  };
}

export function setHeaderUnit(payload) {
  return {
    type: SET_HEADER_UNIT,
    payload: payload,
  };
}

export function updateFilterValue(payload) {
  return {
    type: UPDATE_FILTER_VALUE,
    payload: payload,
  };
}

export function triggerAddCategoryToList() {
  return {
    type: ADD_CATEGORY,
  };
}

export function triggerSetSelectedOptionData(payload, showCategory) {
  return {
    type: SELECTED_OPTION_DATA,
    payload,
    showCategory,
  };
}

export function setSelectedSite(payload) {
  try {
    sessionStorage.setItem("site", payload);
  } catch (error) {
    console.warn("Failed to save site to sessionStorage:", error);
  }
  return {
    type: SET_SELECTED_SITE,
    payload,
  };
}

export function clearDashboardHierarchyReseedFlag() {
  return { type: CLEAR_DASHBOARD_HIERARCHY_RESEED };
}

/**
 * Invoked from DashboardFilterResetListener (Home / back). Bundles:
 * - RESET_FILTERS_TO_DEFAULT (reducer sets needsDashboardHierarchyReseed)
 * - unsetRun (dashboard RUN counter)
 * - resetPayoutDashboardState (payout tiles stay in sync with cleared filters)
 */
export function resetAllDashboardFiltersThunk() {
  return (dispatch) => {
    dispatch({ type: RESET_FILTERS_TO_DEFAULT });
    dispatch(unsetRun());
    dispatch(resetPayoutDashboardState());
  };
}
